<div class="central">
    <img src="assets/images/popup.png">
    <span>Create Your Menu</span>
</div>
<div class="cards-container">
    <div class="card" (click)="navigateWithParam('1')">
        <div class="card-content">
           
            <img src="assets/images/butterfly.png">
            <h2>Wedding</h2>
        </div>
    </div>
    <div class="card" (click)="navigateWithParam('2')">
        <div class="card-content">
            <img src="assets/images/cakecandle.png">
            <h2>Birthday Party</h2>
        </div>
    </div>
    <div class="card" (click)="navigateWithParam('3')">
        <div class="card-content">
            
            <img src="assets/images/valentines.png">
            <h2>Anniversary</h2>
        </div>
    </div>
    <div class="card" (click)="navigateWithParam('4')">
        <div class="card-content">
          
            <img src="assets/images/puja.png">
            <h2>Puja</h2>
        </div>
    </div>
    <div class="card" (click)="navigateWithParam('5')">
        <div class="card-content">
          
            <img src="assets/images/drink.png">
            <h2>Corporate Events</h2>
        </div>
    </div>
    <div class="card">
        <div class="card-content">
          
            <img src="assets/images/packet.png">
            <h2>Packed Food Services</h2>
        </div>
    </div>
</div>